import angular from 'angular'
import './edit/edit.controller'
import './translation.service'

angular
  .module('pub.drop.translation', ['pub.drop.translation.service', 'pub.drop.translation.edit'])
  .controller('TranslationDropCtrl', TranslationDropCtrl)

/** @ngInject */
function TranslationDropCtrl($rootScope, $stateParams, $timeout, TranslationDropService) {
  $rootScope.page = 'page'
  var vm = this
  vm.items = []

  function load() {
    TranslationDropService.listTranslations($stateParams.parentId).then(function (result) {
      vm.items = result.results
    })
  }

  load()

  vm.deleteTranslate = function (id) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          TranslationDropService.removeTranslation(id).then(
            function () {
              load()
            },
            function (err) {
              $timeout(function () {
                swal(err.error.message, '', 'error')
              }, 500)
            },
          )
        } else {
          return
        }
      },
    )
  }
}
